<template>
    <div>
        <div class="app-overlay" :class="{ hide: !isOpen }"></div>
        <div class="app-modal" :class="{ hide: !isOpen }">
            <div class="app-modal__close" @click="closeModal"></div>
            <div class="app-modal__header flex">
                <div class="subtitle1 app-modal__title">
                    {{
                        collectionId
                            ? 'Редактировать коллекцию'
                            : 'Новая коллекция'
                    }}
                </div>
            </div>
            <div class="app-modal__body">
                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label required"
                        for="collection"
                        >Название коллекции</label
                    >
                    <input
                        id="collection"
                        v-model="name"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{ error: $v.name.$dirty && $v.name.$invalid }"
                    />
                    <div
                        v-if="$v.name.$dirty && $v.name.$invalid"
                        class="error-label"
                    >
                        Поле необходимо заполнить
                    </div>
                </div>

                <div
                    class="cabinet-form-group"
                    :class="{ error: $v.brand.$dirty && $v.brand.$invalid }"
                >
                    <label class="cabinet-form-group__label required"
                        >Бренд</label
                    >
                    <select-picker
                        :current-value="brand"
                        :options="brands"
                        key-value="BrandID"
                        key-title="BrandName"
                        select-title="Выберите"
                        :classes="['select', 'select--product-form']"
                        :disabled="isSelectBrandDisabled"
                        @onChange="onSelectPickerChange($event)"
                    />
                    <div
                        v-if="$v.brand.$dirty && $v.brand.$invalid"
                        class="error-label"
                    >
                        Поле необходимо заполнить
                    </div>
                </div>
            </div>
            <div class="app-modal__footer flex">
                <button
                    v-if="backBtn"
                    type="button"
                    class="cabinet-btn--form-back"
                    :disabled="loading"
                    @click="backModal"
                ></button>

                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default js-modal-close ml-auto"
                    :disabled="loading"
                    @click="closeModal"
                >
                    Отменить
                </button>
                <button
                    v-if="collectionId"
                    type="button"
                    class="cabinet-btn js-modal-close app-modal__btn"
                    :class="{ loading: loading }"
                    :disabled="loading"
                    @click="onUpdateCollection"
                >
                    Сохранить
                </button>
                <button
                    v-else
                    type="button"
                    class="cabinet-btn js-modal-close app-modal__btn"
                    :class="{ loading: loading }"
                    :disabled="loading"
                    @click="onCreateCollection"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SelectPicker from '@/components/Elements/SelectPicker'
import getNameById from '@/mixins/getNameById'
import { mapState, mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'

const validations = {
    brand: { required },
    name: {
        required,
        maxLength: maxLength(150)
    }
}

export default {
    name: 'CreateCollection',
    components: { SelectPicker },
    mixins: [getNameById],
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        backBtn: {
            type: Boolean,
            default: false
        },
        brandId: {
            // eslint-disable-next-line
            type: Number | String,
            default: ''
        },
        isSelectBrandDisabled: {
            type: Boolean,
            default: true
        },
        collectionId: {
            //on update collection
            // eslint-disable-next-line
            type: Number | String,
            default: ''
        }
    },
    data() {
        return {
            name: '',
            brand: '',
            loading: false
        }
    },
    validations,
    computed: {
        ...mapState('supplierBrand', ['brands']),
        ...mapState('supplierCollections', ['collections'])
    },
    watch: {
        // brandId: function(val) {
        //     if (!this.brand && val) {
        //         this.brand = val
        //     }
        // },
        isOpen: function(val) {
            if (val) {
                this.brand = this.brandId
                this.name = this.collectionId
                    ? this.getNameById(
                          this.collections,
                          'Name',
                          'CollectionID',
                          this.collectionId
                      )
                    : ''
            }
        }
    },
    mounted() {
        if (!this.brands.length) {
            this.getBrands()
        }
    },
    methods: {
        ...mapActions('supplierBrand', ['getBrands']),
        ...mapActions('supplierCollections', [
            'getCollections',
            'createCollection',
            'updateCollection'
        ]),
        closeModal() {
            this.$emit('closeModal')
        },
        backModal() {
            this.$emit('backModal')
        },
        onSelectPickerChange(val) {
            // console.log('val ' + val)
            // console.log(this.brand)
            this.brand = parseInt(val)
        },
        async onCreateCollection() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true

                try {
                    const resp = await this.createCollection({
                        BrandID: this.brand,
                        Name: this.name
                    })

                    this.$notify({
                        title: 'Выполнено успешно',
                        type: 'success'
                    })

                    this.name = ''
                    this.closeModal()

                    this.getCollections()
                    this.$emit('onCreateCollection', resp.CollectionID)
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }
                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        },
        async onUpdateCollection() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true

                try {
                    const resp = await this.updateCollection({
                        id: this.collectionId,
                        data: {
                            Name: this.name
                        }
                    })

                    this.$notify({
                        title: 'Выполнено успешно',
                        type: 'success'
                    })

                    this.name = ''
                    this.closeModal()

                    this.getCollections()
                    this.getCollections({ existing: true })
                    this.$emit('onUpdateCollection', resp.CollectionID)
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }
                this.loading = false
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        }
    }
}
</script>
